import React from "react";
import { createRoot } from 'react-dom/client';
import App from "./App.jsx";
import "./index.css";
import Loader from "./components/Loader.jsx";

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<>
    <Loader />
    <App />
  </>);

